$(function() {
    // 監視対象のオプション設定
    const observerOptions = {
        root: null, // ビューポートを基準にする
        rootMargin: '0px',
        threshold: 0.2 // 20% 画面に入ったら実行
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 画面に入ったら .is-show クラスを付ける
                $(entry.target).addClass('js-active');
                // 一度表示されたら監視を止める（何度も動かしたい場合はここを消す）
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // .js-fadein がついた要素をすべて監視登録
    $('.c-fadein').each(function() {
        observer.observe(this);
    });
});